import { useNavigate } from "react-router-dom";
export default function EmptySessionCard() {
  const navigate = useNavigate();
  return (
    <div className="w-full flex flex-col justify-start items-start space-y-[14px]">
      {/* upcoming classes list filter button */}
      <div className="w-full flex justify-end items-center">
        <button className="flex justify-center items-center space-x-[12px]">
          {/* filter icon */}
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.668 8.33301L1.66797 8.33301"
              stroke="#E83C70"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8.33203 11.667H1.66536"
              stroke="#E83C70"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M5 15H1.66667"
              stroke="#E83C70"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M15 5L1.66667 5"
              stroke="#E83C70"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M15.832 8.33366V16.667M15.832 16.667L18.332 14.167M15.832 16.667L13.332 14.167"
              stroke="#E83C70"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          {/* filter text */}
          <span className="text-[#E83C70] font-inter font-normal text-[14px] leading-[24px] ">
            Newest First
          </span>
        </button>
      </div>
      {/* upcoming classes list */}
      <div className="w-full h-[568px] flex justify-center items-start p-[14px] border border-[#DFDFDF] rounded-[20px]">
        <div className="w-[276px] h-[380px] flex flex-col justify-center items-center space-y-[22px] text-center">
          <img
            src="/images/empty-folder.png"
            alt="empty filter"
            className="w-[207px] h-[207px] object-cover"
          />
          {/* empty classes texts */}
          <div className="flex flex-col justify-center items-center space-y-[6px]">
            <p className="text-[#370513] font-inter font-semibold text-[22px] leading-[32px] ">
              It’s pretty quiet in here...
            </p>
            <p className="text-[#1B0209] font-inter font-normal text-[16px] leading-[25px] text-opacity-80 ">
              Time to change that. Explore and find a course that you like!
            </p>
          </div>
          {/* explore courses button that redirects to /courses */}
          <button
            type="button"
            className="w-full rounded-[12px] py-[12px] px-[34px] border border-[#E83C70] hover:bg-[#FFECF2] hover:border-[2px] hover:border-[#E83C70] active:bg-[#FFC9D9] active:border-[2px] active:border-[#E83C70]"
            onClick={() => navigate("/courses")}
          >
            <span className="text-[#E83C70] font-inter font-semibold text-[14px] leading-[26px] ">
              Explore Courses
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
